<template>
    <CommonTitleTemplate
        v-bind="$attrs"
        :tag-list="getTagList"
        @change-tag="changeHandle"
        @go-more="goMoreHandle"
    ></CommonTitleTemplate>
    <News :data="showList" v-bind="$attrs" :type="currentTab"></News>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue';
import CommonTitleTemplate from '../components/common-title-list.vue';
import News from './news.vue';
import dayjs from 'dayjs';
import { pageJump } from '@/global/location-transfer';

const emit = defineEmits(['']);
const props = defineProps({
    // 是否显示新闻动态
    showNews: {
        type: Boolean,
        default: true,
    },
    // 是否显示通知公告
    showNotice: {
        type: Boolean,
        default: true,
    },
    // 显示条数
    limit: {
        type: Number,
        default: 6,
    },
});

const tabList = [
    { key: 'notice', name: '通知公告' },
    { key: 'news', name: '新闻动态' },
];

// 应用类型对应
const instAppTypeMap = {
    topic: '1', // 专题
    lesson: '2', // 同步备课
    banner: '3', // banner
    notice: '4', // 通知公告
    information: '5', // 新闻资讯
    expert_team: '6', // 专家团队
    monitor: '7', // 测评
    cooperateOrg: '8', // 合作机构
    quick: '9', // 快捷入口
    yanxiu_star: '10', // 研修之星
    portal: '11', // 门户
};

// 排序类型对应
const orderTypeMap = {
    banner: 'sort',
    notice: 'recommend',
    information: 'recommend',
    quick: 'sort',
};

const data = reactive({
    bannerList: [], // banner列表
    newsList: [], // 新闻咨询列表
    noticeList: [], // 通知公告列表数据
    quickList: [], // 快捷入口列表数据
});

const currentTab = ref<'news' | 'notice'>();

const getTagList = computed(() =>
    tabList.filter(
        item =>
            (item.key === 'notice' && props.showNotice) || (item.key === 'news' && props.showNews),
    ),
);

const showList = computed(() => {
    switch (currentTab.value) {
        case 'notice':
            return data.noticeList;
        case 'news':
            return data.newsList;
    }
    return [];
});

// 获取banner/新闻咨询/通知公告/快捷入口数据
const getFirstScreenContent = type => {
    let params = getRequestParams(type);
    G_transmit('getFirstScreenContent', {
        name: 'getFirstScreenContent',
        queries: params,
    }).then(res => {
        let result = res?.data?.rows || [];
        result.forEach(item => {
            item.publishTime = dayjs(item.publishTime).format('YYYY.MM.DD');
        });
        switch (type) {
            case 'banner':
                data.bannerList = result;
                break;
            case 'information':
                data.newsList = result;
                break;
            case 'notice':
                data.noticeList = result;
                break;
            case 'quick':
                data.quickList = result;
                break;
        }
    });
};

function getRequestParams(type) {
    let params: Record<string, any> = {
        instAppTypeId: instAppTypeMap[type],
        pageIndex: 1,
        pageSize: props.limit,
        orderType: orderTypeMap[type],
        publishPlace: 'PC',
        publishState: 1, // 发布状态
    };
    switch (type) {
        case 'quick': {
            params = {
                ...params,
                publishPlace: undefined,
            };
            break;
        }
    }
    return params;
}

function changeHandle(val) {
    currentTab.value = val;
}

function goMoreHandle() {
    pageJump({ name: currentTab.value === 'news' ? 'information' : 'notice' });
}

onMounted(() => {
    // 获取新闻咨询数据
    getFirstScreenContent('information');
    // 获取通知公告数据
    getFirstScreenContent('notice');
    currentTab.value = getTagList.value[0]?.key;
});
</script>

<style lang="scss" scoped>
.container {
}
</style>
